import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'semantic-ui-react';
import { reduxForm, Field, FieldArray } from 'redux-form';
import _ from 'lodash';
import ReactTable from 'react-table';
import { connect } from 'react-redux';

import { InputField, Select } from 'Common/SemanticWrapper';
import { INGREDIENT_GROUPS_FORM_NAME } from 'Common/FormEnum';
import {
  ControlInfoIngredientGroupsFormEnum as Fields,
  IngredientGroupFieldEnum,
} from 'Common/FieldEnum';
import {
  ReactTableWrapperColumnProperties,
  ReactTableWrapperCogColumnProperties,
} from 'Common/Constants';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import { setNotificationDialog } from 'Components/dialogs/state/actions';
import { NOTIFICATION_DIALOG_MESSAGES } from 'Common/Constants';
import { createToast, toastType } from 'Common/ToastHelper';

import * as IngredientGroupsSelectors from '../state/ingredientGroup/selectors';
import * as IngredientGroupActions from '../state/ingredientGroup/actions';
import { LOCAL_SOURCE_ID } from '../helpers';

class IngredientGroupTable extends React.Component {
  static propTypes = {
    isReadOnly: PropTypes.bool.isRequired,
  };
  menuOptions = [
    {
      icon: 'trash',
      text: 'Delete',
      className: 'danger',
      handler: row => {
        const { dispatch, fields } = this.props;
        dispatch(
          setNotificationDialog({
            ...NOTIFICATION_DIALOG_MESSAGES.REMOVE_INGREDIENT_GROUP,
            functionsToRunOnOk: [
              async () => {
                const path = _.toPath(row);
                const index = Number(path[1]);

                const field = fields.get(index);

                if (field && field.Id) {
                  const updatedFields = fields
                    .getAll()
                    .filter((x, i) => index !== i);

                  dispatch(
                    IngredientGroupActions.deleteIngredientGroups(updatedFields)
                  );
                } else {
                  fields.remove(index);
                  createToast(
                    toastType.success,
                    'Success',
                    'Deleted Ingredient Group',
                    true
                  );
                }
              },
            ],
          })
        );
      },
      disabledWhen: row => {
        const { isReadOnly, getIsGroupReadOnly } = this.props;
        const isGroupReadOnly = getIsGroupReadOnly(row);
        return isReadOnly || isGroupReadOnly;
      },
    },
  ];
  render() {
    const {
      fields,
      ingredientSourcesOptions,
      getIsGroupReadOnly,
      isReadOnly,
    } = this.props;
    return (
      <React.Fragment>
        <ReactTable
          data={fields}
          pageSize={fields.length}
          showPageSizeOptions={false}
          showPagination={false}
          minRows={3}
          columns={[
            {
              id: 'IngredientSourceId',
              Header: 'Source',
              Cell: row => {
                const name = `${row.original}.${
                  IngredientGroupFieldEnum.IngredientSourceId
                }`;
                return (
                  <Field
                    name={name}
                    component={Select}
                    fluid={true}
                    options={ingredientSourcesOptions}
                    usePortal
                    disabled
                  />
                );
              },
              ...ReactTableWrapperColumnProperties,
              sortable: false,
              filterable: false,
              width: 200,
            },
            {
              id: 'Description',
              Header: 'Group Name',
              Cell: row => {
                const name = `${row.original}.${
                  IngredientGroupFieldEnum.Description
                }`;

                const isGroupReadOnly = getIsGroupReadOnly(row.original);
                return (
                  <Field
                    name={name}
                    maxLength={70}
                    component={InputField}
                    fluid={true}
                    showOnlyTouchedError={true}
                    hideEmptyError={true}
                    disabled={isGroupReadOnly || isReadOnly}
                  />
                );
              },
              ...ReactTableWrapperColumnProperties,
              sortable: false,
              filterable: false,
            },
            {
              ...ReactTableWrapperCogColumnProperties,
              Cell: gridProps => {
                return GridContextMenu({
                  gridProps,
                  options: this.menuOptions,
                });
              },
            },
          ]}
        />
        {!isReadOnly && (
          <Button
            onClick={() =>
              fields.push({
                [IngredientGroupFieldEnum.IngredientSourceId]: LOCAL_SOURCE_ID,
              })
            }
          >
            Add New
          </Button>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  ingredientSourcesOptions: IngredientGroupsSelectors.getIngredientSourcesOptions(
    state
  ),
  getIsGroupReadOnly: field =>
    IngredientGroupsSelectors.getIsIngredientGroupReadOnly(state, field),
});

IngredientGroupTable = connect(mapStateToProps)(IngredientGroupTable);

class IngredientGroupsForm extends React.Component {
  static propTypes = {
    isReadOnly: PropTypes.bool.isRequired,
  };
  render() {
    const { isReadOnly } = this.props;
    return (
      <FieldArray
        name={Fields.IngredientGroups}
        component={IngredientGroupTable}
        isReadOnly={isReadOnly}
      />
    );
  }
}

const validate = (values, props) => {
  const errors = {};
  const ingredientGroups = values[Fields.IngredientGroups];

  const ingredientGroupErrors = [];

  if (Array.isArray(ingredientGroups)) {
    ingredientGroups.forEach((ingredientGroup, index) => {
      const ingredientGroupError = {};
      const description = _.trim(
        _.toUpper(_.get(ingredientGroup, IngredientGroupFieldEnum.Description))
      );

      if (!description) {
        ingredientGroupError[IngredientGroupFieldEnum.Description] =
          'Description is required.';
      } else {
        const { true: numInstances } = _.countBy(ingredientGroups, x => {
          return _.trim(_.toUpper(x.Description)) === description;
        });

        if (numInstances > 1) {
          ingredientGroupError[IngredientGroupFieldEnum.Description] =
            'Description must be unique.';
        }
      }
      ingredientGroupErrors[index] = ingredientGroupError;
    });
  }

  errors[Fields.IngredientGroups] = ingredientGroupErrors;
  return errors;
};

IngredientGroupsForm = reduxForm({
  form: INGREDIENT_GROUPS_FORM_NAME,
  validate,
  destroyOnUnmount: false,
})(IngredientGroupsForm);

export { IngredientGroupsForm };



// WEBPACK FOOTER //
// ./src/pages/controlinformation/components/IngredientGroupsForm.js